import SupportCard from "./SupportCard";

const Card = Object.assign({
  Support: SupportCard,
});

export default Card;
